import state from '@/stores/ui/state.js'
import mutations from '@/stores/ui/mutations.js'
import actions from '@/stores/ui/actions.js'

export default {
  state,
  mutations,
  actions
}
